const shouldDisplayMedicationRecord = (
  relationType: "F" | "C" | null,
  showMyChartMedication: boolean,
) =>
  relationType === "F" || relationType === "C" ? false : showMyChartMedication;

export { shouldDisplayMedicationRecord };
